import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-wbmsalinity-vertical',
  standalone: false,
  templateUrl: './wbmsalinity-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class WbmSalinityVerticalComponent {
@Input() wmbsalinityTest:any
}

